import { bl_mlm_program_hdr_RowClass } from "../../../dbschema";
import { BaseContainerModel } from "../../base-container.model";


export class MlmProgramContainerModel extends BaseContainerModel {

    bl_mlm_program_hdr : bl_mlm_program_hdr_RowClass = new bl_mlm_program_hdr_RowClass();
}